const triggerUserRegistration = (country ,lang , sessionId , externalRefId ,customerRequestBody) => {
  
    const customerHeaders = {
        "Accept-Language": `${lang}-${country}`,
        "Content-Type": `application/json`,
        "x-wu-correlationId":  sessionId,
        "x-wu-externalRefId":  externalRefId,
        "WuCountryCode": country,
        "WuLanguageCode": lang,
        "x-wu-sessionId": sessionId,
        "accept": `application/json`,
        "x-wu-operationName": "addCustomer",
        "x-wu-global-mfa" :true,
        "isAutoEnabled":false,
        "x-wu-session-version":3,
        "isrrenabled":false,
        "applicationSource": "WHATSAPP"
      };

     
      const requestOptions = {
        method: "POST",
        body: JSON.stringify(customerRequestBody),
        headers: customerHeaders, 
      };
    
     try {
      return fetchApiWu(
         "/auth/v2/register/customer",
         requestOptions,
         "fullRegisterCustomer"
       ).then((customerResponse) => {
            return customerResponse;     
       });
     } catch (e) {
       console.log(e);
       return "error";
     }
    
    }

window.queryData.triggerUserRegistration = triggerUserRegistration;    